// src/routes/dashboard/components/DashboardSkeleton.tsx
/** Placeholder mostrato durante il primo caricamento della dashboard, a specchio del layout reale. */
import React from 'react';
import { SimpleGrid, Skeleton, Stack, Grid } from '@mantine/core';

export function DashboardSkeleton() {
  return (
    <Stack gap="lg">
      <SimpleGrid cols={{ base: 1, sm: 2, md: 4 }} spacing="lg">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} height={110} radius="md" />
        ))}
      </SimpleGrid>

      <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="lg">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} height={140} radius="md" />
        ))}
      </SimpleGrid>

      <Grid>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Skeleton height={320} radius="md" />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Skeleton height={320} radius="md" />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={{ base: 12, md: 7 }}>
          <Skeleton height={300} radius="md" />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 5 }}>
          <Skeleton height={300} radius="md" />
        </Grid.Col>
      </Grid>
    </Stack>
  );
}
